import React, { useState, useEffect } from 'react';
import Proptypes from 'prop-types';

import API from 'services/API';
import JWTService from 'services/JWT';
import AUTHContext from './context';
import { useNavigate } from 'react-router-dom';

const Auth = ({ children }) => {
  const navigate = useNavigate();
  const [loading, isLoading] = useState(false);
  const [user, setUser] = useState(null);

  const JWTCheck = () =>
    new Promise((resolve) => {
      JWTService.on('onAutoLogin', (data) => {
        if (data) {
          setUser(data.data);
        }
      });

      JWTService.on('onAutoLogout', (message) => {
        setUser(null);
        navigate('/login');
        resolve();
      });

      JWTService.on('onNoAccessToken', () => {
        resolve();
      });

      JWTService.on('onLogged', (data) => {
        if (data) {
          setUser(data);
        }
      });
      JWTService.on('onExpiredPassword', (token) => {
        if (token) {
          navigate(`/newpassword?action=create&token=${encodeURIComponent(token)}`);
        }
        resolve();
      });

      JWTService.init();

      return Promise.resolve();
    });

  /**
   * Component Did Mount for call JWT Check
   */
  useEffect(() => {
    JWTCheck()
      .then(() => isLoading(false))
      .catch(() => console.error('redirect login'));
  }, []);

  const logout = () => {
    try {
      const refresh_token = localStorage.getItem('jwt_refresh_token');
      if (refresh_token) {
        API.post('token/invalidate', { refresh_token: refresh_token });
      }
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('jwt_refresh_token');
      localStorage.removeItem('cooperative');
      localStorage.removeItem('exploitation');
      localStorage.removeItem('sector');
      localStorage.removeItem('filteredCultures');
      localStorage.removeItem('filteredRotationEffects');
      localStorage.removeItem('isOrganic');
      localStorage.removeItem('i18n_language');

      delete API.defaults.headers.common.Authorization;
    } catch (error) {
      console.error(error);
    }
    setUser(null);
  };

  return loading ? null : (
    <AUTHContext.Provider
      value={{
        user,
        setUser,
        logout,
      }}
    >
      {children}
    </AUTHContext.Provider>
  );
};

Auth.propTypes = {
  children: Proptypes.element.isRequired,
};

export default Auth;
